const pageTypes = {
    PURCHASE_WIDGET_SDK_PAGE: "PaidHealthReportWidget_page",
};

export default pageTypes;
